import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  FirestoreDataConverter,
} from 'firebase/firestore';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { firestore } from '@/lib/firebase';
import { normalizePhone } from '@/lib/phone';

export interface Contact {
  id?: string;
  name: string;
  number: string;
}

const converter: FirestoreDataConverter<Contact> = {
  toFirestore: (contact) => {
    const data = { ...contact };
    delete data.id;
    return data;
  },
  fromFirestore: (snapshot) => {
    const d = snapshot.data();
    return { id: snapshot.id, name: d.name, number: d.number };
  },
};

export function useContacts() {
  return useCollectionData(
    collection(firestore, 'contacts').withConverter(converter),
    { snapshotListenOptions: { includeMetadataChanges: false } }
  );
}

export function addContact(name: string, number: string) {
  return addDoc(collection(firestore, 'contacts'), {
    name,
    number: normalizePhone(number),
  });
}

export function removeContact(id: string) {
  return deleteDoc(doc(firestore, 'contacts', id));
}
